import { arm_sleeves } from './arm_sleeves';
import { banner } from './banner';
import { batpack } from './batpack';
import { blanket } from './blanket';
import { bp_jacket } from './bp_jacket';
import { clutch_cage_jacket } from './clutch_cage_jacket';
import { drawstring_bag } from './drawstring_bag';
import { flag } from './flag';
import { flywheel_pullover } from './flywheel_pullover';
import { gladiator_hoodie } from './gladiator_hoodie';
import { golf_polo } from './golf_polo';
import { headband } from './headband';
import { hockey_hoodie } from './hockey_hoodie';
import { hyperlite_gloves } from './hyperlite_gloves';
import { hyperpolo } from './hyperpolo';
import { hypertee } from './hypertee';
import { jackal_jacket } from './jackal_jacket';
import { nano_pullover } from './nano_pullover';
import { pennant } from './pennant';
import { pro_premier_pullover } from './pro_premier_pullover';
import { quadflex_hoodie } from './quadflex_hoodie';
import { retro_mesh_shorts } from './retro_mesh_shorts';
import { revolution_shorts } from './revolution_shorts';
import { roller_bat_bag } from './roller_bat_bag';
import { socks } from './socks';
import { vulcan_hoodie } from './vulcan_hoodie';
import { vulcan_pullover } from './vulcan_pullover';

export const apparel = {
  headband,
  hypertee,
  hyperpolo,
  golf_polo,
  revolution_shorts,
  retro_mesh_shorts,
  bp_jacket,
  clutch_cage_jacket,
  flywheel_pullover,
  jackal_jacket,
  nano_pullover,
  pro_premier_pullover,
  vulcan_hoodie,
  gladiator_hoodie,
  hockey_hoodie,
  quadflex_hoodie,
  vulcan_pullover,
  arm_sleeves,
  socks,
  batpack,
  roller_bat_bag,
  drawstring_bag,
  hyperlite_gloves,
  blanket,
  flag,
  banner,
  pennant,
};
